/* eslint-disable no-process-env */
const webAppHostMap = {
  "m.mynexia.com": "https://www.mynexia.com",
  "m-qa.nexiadev.com": "https://qa.nexiadev.com",
  "m-qa2.nexiadev.com": "https://qa2.nexiadev.com",
  "m-demo.mynexia.com": "https://demo.mynexia.com",
  "m-lab.nexiadev.com": "https://lab.nexiadev.com",
  "m-pivot.mynexia.com": "https://www.mynexia.com",
  "m-pivot-qa.nexiadev.com": "https://qa.nexiadev.com",
  "qa-pivot.trane.com": "https://qa.nexiadev.com",
};

const Environment = {
  PRODUCTION_HOST: "https://www.mynexia.com",

  isProductionDeployTarget() {
    return process.env.NODE_ENV === "production";
  },

  isTestRunner() {
    return process.env.NODE_ENV === "test" || this.isJest();
  },

  isJest() {
    return typeof jest !== "undefined";
  },

  isCommercial() {
    return process.env.APP_BRAND === "commercial";
  },

  isTraneCommercial() {
    return (
      process.env.APP_BRAND === "commercial" &&
      process.env.APP_BRAND_TYPE !== "american_standard"
    );
  },

  isAmStdCommercial() {
    return (
      process.env.APP_BRAND === "commercial" &&
      process.env.APP_BRAND_TYPE === "american_standard"
    );
  },

  defaultHostForEnvironment() {
    return webAppHostMap[window.location.hostname] || this.PRODUCTION_HOST;
  },
};

export default Environment;



// WEBPACK FOOTER //
// ./src/environment.js